import { Component, OnInit } from '@angular/core';
import { NotificationBuilder } from "../../shared/notificationBuilder";
import { Product } from "../../models/productStore.model";
import { ProfileService } from "../profile.service";
import { NgxSmartModalService } from "ngx-smart-modal";
import { FormGroup, FormBuilder } from "@angular/forms";
import { AuthenticationService } from "src/app/authentication/authentication.service";

declare var swal: any;
@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.css']
})
export class ProductsComponent implements OnInit {
  public isAdmin: boolean;
  public productsList: Product[];
  public productEdit: Product;  loading: boolean;
  private producStore: any;
  private user: any;
  userForm: FormGroup;
  newUserForm: FormGroup;
  show: boolean;
  condicao: boolean = false;
  showRegister: boolean = false;
  isDataValid: boolean = false;
  product: Product = new Product();

  constructor(
    private profileService: ProfileService,
    private authenticationService: AuthenticationService,
    public ngxSmartModalService: NgxSmartModalService,
    private notificationBuilder: NotificationBuilder,
    private formBuilder: FormBuilder
  ) { }

  ngOnInit(): void {
    this.loading = true;
    this.isAdmin = this.authenticationService.isAdministrator();

    this.profileService.getCurrentUserInfo().subscribe( data => {
      if(data != null)
      {
        this.user = data;
        this.profileService.getProductStore(this.user.storeSeoName).subscribe(res => {
          if (res.success) {
            this.producStore = res.productStore;
            if(this.producStore.products != null)
            {
              this.productsList = this.producStore.products;
            }else{
              this.notificationBuilder.showNotification('danger', 1000, 'Não foi possível encontra uma lista de Produtos.');
            }

          }
        })
      }else{
        this.notificationBuilder.showNotification('danger', 1000, 'Não foi possível carregar o ProductStore');
      }
      this.loading = false;
    })

    
  }

  changeProductList() 
  {
    if(this.productEdit.isEditable)
    {
      this.updateProduct();
    }else{
      this.createProduct();
    }
    
  }

  createProduct()
  {
    debugger
    var obj = this;
    this.loading = true;
    this.profileService.createProduct(this.productEdit, this.user.storeSeoName).subscribe(data => {
      if (data.success) {
        obj.productEdit = new Product();
        obj.showRegister = false;
        obj.notificationBuilder.showNotification('success', 1000, 'O cadastro foi realizado com sucesso')
        window.location.reload();
      } else {
        obj.notificationBuilder.showNotification('danger', 1000, data.error)
      }
    })
  }

  editProduct(product: Product) {
    debugger
    $("html, body").animate({ scrollTop: 0 }, 2000);
    if (product == null) {
      this.productEdit = new Product()
    }
    else {
      this.productEdit = product;
      this.productEdit.isEditable = true;
    }

    this.showRegister = true;
  }

  deleteProduct(product : Product) {
    var obj = this;
    swal({
      title: 'Tem certeza que deseja deletar?',
      text: "Ao deletar este produto, é um",
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Confirmar',
      cancelButtonText: 'Voltar',
      reverseButtons: true
    }).then((result) => {
      debugger
      if (result) {
        this.profileService.deleteProduct(product, this.user.storeSeoName).subscribe(data => {
          if (data.success) {
            obj.notificationBuilder.showNotification('success', 1000, 'O cadastro foi deletado com sucesso')
            window.location.reload();
          }
          else {
            obj.notificationBuilder.showNotification('danger', 1000, data.error)
          }
        });
      }
    })

  }

  onEdit(){
    
  }

  updateProduct()
  {
    debugger
    var obj = this;
    this.loading = true;
    this.profileService.editProduct(this.productEdit, this.user.storeSeoName).subscribe(data => {
      console.log(data);
      if (data.success) {
        obj.productEdit = new Product();
        obj.showRegister = false;
        obj.notificationBuilder.showNotification('success', 1000, 'A edição foi realizada com sucesso')
        window.location.reload();
      } else {
        obj.notificationBuilder.showNotification('danger', 1000, data.error)
      }
    })
  }

  validateSku() {
    return !(this.productEdit.productSku != '' && this.productEdit.productSku != null);
  }

  validateName() {
    return !(this.productEdit.productName != '' && this.productEdit.productName != null);
  }

  validateUrl()
  {
    return !(this.productEdit.productUrl != '' && this.productEdit.productUrl != null);
  }

  validateId()
  {
    return !(this.productEdit.productId != '' && this.productEdit.productId != null);
  }

  validateDonation()
  {
    console.log(this.productEdit.donation)
    return !(this.productEdit.donation > 0 && this.productEdit.donation <= 100);
  }

}
